import React from 'react';
import { bonuses } from '../data/landing';
export function BonusesSection() {
  return <section id="bonos" className="scroll-mt-16 border-t border-line bg-night" data-id="element-31" data-mp="gvvli9ih9ake">
      <div className="mx-auto max-w-6xl px-5 py-10 md:px-6 md:py-16 lg:py-20" data-id="element-32" data-mp="vswc29oxmzha">
        <div className="max-w-3xl" data-id="element-33" data-mp="vqtbivq5lnyb">
          <p className="text-xs text-gold md:text-sm" data-id="element-34" data-mp="qt9z81d0nl90">Tu próximo paso hacia una exploración más profunda</p>
          <h2 className="mt-2 font-display text-2xl text-cream md:text-4xl" data-id="element-35" data-mp="14t2ortct3vfe">
            El Libro del Despertar
          </h2>
          <p className="mt-1 font-serif text-base italic text-muted md:text-xl" data-id="element-36" data-mp="ztq0r5a78ib8">
            Edición digital en español.
          </p>
          <p className="mt-3 text-sm leading-relaxed text-cream/85 md:text-lg" data-id="element-37" data-mp="1el8dmu7rhwqd">
            Un libro para explorar conceptos relacionados con la conciencia, la
            percepción, la mente y el simbolismo ancestral a través de una
            lectura que invita a reflexionar y conectar ideas.
          </p>
        </div>

        <div className="mt-8 md:mt-12" data-id="element-38" data-mp="3pqtv8oxv65gy">
          <h3 className="font-display text-lg text-cream md:text-2xl" data-id="element-39" data-mp="3prwk6rbmlxu8">
            3 bonos exclusivos incluidos
          </h3>
          <div className="mt-3 border-t border-line md:mt-6" data-id="element-40" data-mp="3ttqjav66atsa">
            {bonuses.map(b => <article key={b.label} className="grid gap-1.5 border-b border-line py-4 md:grid-cols-[8rem_1fr_1fr] md:gap-10 md:py-7" data-id="element-41" data-mp="2nyvi2fvbt8n">
                <p className="font-display text-xs tracking-[0.15em] text-gold md:text-sm" data-id="element-42" data-mp="cjjsfm62y3bj">
                  {b.label}
                </p>
                <div data-id="element-43" data-mp="lcdmipq6r79g">
                  <h4 className="font-display text-base leading-snug text-cream md:text-lg" data-id="element-44" data-mp="lbu4za4g6kvy">
                    {b.title}
                  </h4>
                  <p className="mt-1 text-sm md:mt-2 leading-relaxed text-cream/80 md:text-base" data-id="element-45" data-mp="qdazmnwc9b43">
                    {b.lead}
                  </p>
                </div>
                <p className="text-sm leading-relaxed text-muted md:pt-8 md:text-base" data-id="element-46" data-mp="10a60hdg33nlj">
                  {b.body}
                </p>
              </article>)}
          </div>
        </div>
      </div>
    </section>;
}